IN.App.ApplicationView = Ember.View.extend({
	enter: function (btn, event) {
		if(event.which == 13){
			btn.click();
		}
	},
	didInsertElement: function(){
		var self = this;
		this.$(window).on("keydown", function(event){
			var nextbutton = self.$(".next-page")

			self.enter(nextbutton, event);
		});
		this.$('.notification').on("keydown", ".form-control", function(event){
			var nextbutton = self.$(".next-page");
			self.enter(nextbutton, event);
		});
	}
});

IN.App.LoginView = Ember.View.extend({
	tooltipMessage: Em.computed.alias('controller.tooltiperror'),
	actions: {
		hideTooltip: function() {
			$("#password-field").tooltip('hide').tooltip('destroy');
		},
		showTooltip: function() {

			var self = this;

			// destroy the tooltip if one already existed.
			if($("#password-field").data('bs.tooltip')) {
				$("#password-field").tooltip('destroy');
			}

			// create a tooltip
			$("#password-field").tooltip({
				title: self.get('tooltipMessage'),
				placement: 'right',
				trigger: 'manual',
				template: '<div class="tooltip tooltip-error" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
			});

			// show the tooltip
			$("#password-field").tooltip('show');

			setTimeout(function() {
				self.send('hideTooltip');
			}, 5000);

		}
	},

	/*
	 * Initializes the google sign in
	 */
	initGoogleSignin: function() {

		// hooks are located in EditaccountController
		var self 		= this;
		var auth2;

		if(gapi) {
			gapi.load('auth2', function() {
				auth2 = gapi.auth2.init({
					client_id: IN.App.googleClientID,
					cookiepolicy: 'single_host_origin'
				});
				self.bindGoogleSignin(self.$('#signin-oauth')[0], auth2);
			});
		}

	}.on('didInsertElement'),

	/*
	 * Binds the signin handler to the google button
	 */
	bindGoogleSignin: function(el, api) {

		var view 		= this;
		var controller 	= this.get('controller');

		api.attachClickHandler(el, {}, function(googleUser) {
			controller.googleSigninSuccess(googleUser, view);
		}, function(error) {
			controller.googleSigninFailure(error, view);
		});
		
	},

	didInsertElement: function() {
		var self = this;
		this.get('controller').set('view', this);

		// listen to the enter key, this is not done by default.

		this.$().find('form#login').bind('keypress', function(e) {
			if(e.keyCode === 13) {
				self.get('controller').send('login');
			}
		});

	}
});
